export default __webpack_public_path__ + "static/media/minute.9130a4e9.png";